// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.i2ImmTMcdszhIjnGPwiK {
    display: flex;
    flex-direction: column;
    padding: 16px 0;
}

.h0P_8_o2jLd4c15IUGqj {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.VXIErPifqDhWgXUghup_ {
    display: flex;
    justify-content: end;
    gap: 8px;
    padding: 8px 8px 16px;
    cursor: pointer;
}

.VXIErPifqDhWgXUghup_:hover {
    opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/AppointmentBooking/components/Provider/Provider.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,QAAQ;IACR,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".wrapper {\n    display: flex;\n    flex-direction: column;\n    padding: 16px 0;\n}\n\n.listWrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.allProvidersWrapper {\n    display: flex;\n    justify-content: end;\n    gap: 8px;\n    padding: 8px 8px 16px;\n    cursor: pointer;\n}\n\n.allProvidersWrapper:hover {\n    opacity: 0.8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `i2ImmTMcdszhIjnGPwiK`,
	"listWrapper": `h0P_8_o2jLd4c15IUGqj`,
	"allProvidersWrapper": `VXIErPifqDhWgXUghup_`
};
export default ___CSS_LOADER_EXPORT___;
